module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter BookTitlePage"
  }, [_c('div', {
    staticClass: "title-block-book"
  }, [_c('p', {
    staticClass: "title-author"
  }, [_vm._v("John Muir")]), _vm._v(" "), _c('h1', [_vm._v("THE WILDERNESS JOURNEYS")]), _vm._v(" "), _c('p', {
    staticClass: "title-sub"
  }, [_vm._v("The Story of "), _c('br'), _vm._v(" My Boyhood and Youth")]), _vm._v(" "), _c('p', {
    staticClass: "title-sub"
  }, [_vm._v("A Thousand Mile Walk to the Gulf")]), _vm._v(" "), _c('p', {
    staticClass: "title-sub"
  }, [_vm._v("My First Summer in the Sierra")]), _vm._v(" "), _c('p', {
    staticClass: "title-sub"
  }, [_vm._v("Travels in Alaska")]), _vm._v(" "), _c('p', {
    staticClass: "title-sub"
  }, [_vm._v("Stickeen")]), _vm._v(" "), _c('p', {
    staticClass: "title-other"
  }, [_c('i', [_vm._v("Introduced by Graham White ")])])]), _vm._v(" "), _c('div', {
    staticClass: "imprint"
  }, [_c('p', [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "logo.png"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b95ffc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675705_booktitlepage.vue
// module id = 60
// module chunks = 0